// extracted by mini-css-extract-plugin
export default {"host":"qP03j__host","wrapper":"AXzXw__wrapper"};